<button class="flex items-center px-6 py-2 rounded-full text-white text-lg font-medium"
        type="button"
        [disabled]="disabled"
        (click)="onBankIdClick($event)">
  <img src="https://deltagerfiles.blob.core.windows.net/assets/DNA-element-white.svg" alt="Logg inn med BankID" class="w-6 h-6 mr-2">
  <ng-content></ng-content>
</button>
